export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7678.c4dac12f.jpg";